import CommunicationsScreen from "./screen";

export default CommunicationsScreen;
